import { PartnerType } from "./PartnerType";
import { LogitudeLookupModel } from "../models/LogitudeLookupModel";
import { TimeZone } from "./TimeZone";

export class User {
  Id: number;
  ExternalId: string;
  Tenant: number;
  FirstName: string;
  LastName: string;
  Email: string;
  Password: string;
  PartnerTypeCode: string;
  PartnerType: PartnerType | null;
  PartnerId: number;
  Partner: LogitudeLookupModel;
  TimeZoneCode: string;
  TimeZone: TimeZone;
  DaylightSavingTime: boolean;
  IsBlocked: boolean;
  IsSupervisorAgent: boolean;
  IsAdministrator: boolean;
}

export class UpdateUser {
  Id: number;
  TimeZoneCode: string;
  DaylightSavingTime: boolean;
  IsSupervisorAgent: boolean;
  IsAdministrator: boolean;
}

export class BlockUnblock {
  Id: number;
  Block: boolean;
}